<template>
  <div class="questionPreview">
    <!-- title -->
    <div class="title">
      <p>题型：{{ questionObj.questionTypeName }}</p>
      <p>难度：{{ questionObj.difficulty == 1 ? "简单" : questionObj.difficulty == 2 ? "中等" : "困难" }}</p>
      <p>建议分数：{{ questionObj.score }}</p>
      <p>创建人：{{ questionObj.createName }}</p>
      <p>创建时间：{{ questionObj.createTime }}</p>
    </div>
    <!-- main -->
    <div>
      <!-- 非组合题 -->
      <div
        v-if="questionObj.internalTypeId != 6"
        class="questionInfo single_question"
      >
        <p class="question_title">
          <span style="display: inline-block; width: calc(100% - 80px)">
            <span>{{ questionObj.taskName ? `【${questionObj.taskName}】` : questionObj.taskName}}</span
            >
          </span>
        </p>
        <!-- 题干 -->
        <div
          class="div_content ql-editor"
          v-html="questionObj.questionContent"
        ></div>
        <!-- 选择题 -->
        <ul
          v-if="
            questionObj.internalTypeId === 1 || questionObj.internalTypeId === 2
          "
        >
          <li
            :class="{
              actived: questionObj.questionAnswer.indexOf(option.itemKey) != -1,
            }"
            v-for="(option, option_index) in questionObj.items"
            :key="option_index"
            v-html="option.itemKey + '. ' + option.itemValue"
          ></li>
        </ul>
        <!-- 答案 解析 知识点 标签 -->
        <div class="answer">
          <!-- 知识点 -->
          <p>
            <span class="label">【知识点】:</span>
            <span
              v-for="(material, mat_index) in questionObj.materials"
              :key="mat_index"
            >
              <el-tag
                v-if="material"
                size="mini"
                :title="material.name"
                class="my_tag"
                >{{ material.name }}</el-tag
              >
            </span>
          </p>
          <!-- 公司 -->
          <p>
            <span class="label">【公司】:</span>
            <span>{{ questionObj.companyNameUp }}</span>
          </p>
          <!-- 标签 -->
          <p>
            <span class="label">【标签】:</span>
            <el-tag
              v-for="(
                personLabel, personLabel_index
              ) in questionObj.personLabels"
              :key="personLabel_index"
              size="mini"
              :title="personLabel.labelName"
              class="my_tag"
              >{{ personLabel.labelName }}</el-tag
            >
          </p>
          <!-- 备注 -->
          <p>
            <span class="label">【备注】:</span>
            <span> 修改人：{{ questionObj.updateName }} </span>
            <span class="updateTime">
              修改时间：{{ questionObj.updateTime }}
            </span>
          </p>

          <!-- 答案 -->
          <!-- <p
            class="answer_blue lineH20"
            v-if="
              item.internalTypeId !== 9 &&
              item.internalTypeId !== 10 &&
              item.internalTypeId !== 4
            "
            v-html="'【答案】' + item.questionAnswer"
          ></p>
          <ul v-if="item.internalTypeId === 4">
            【答案】
            <li v-for="(val, i, index) in item.newQuestionAnswer" :key="index">
              {{ index + 1 }}、正确答案：<span
                v-for="(answerVal, index) in val"
                :key="index"
                >{{ answerVal
                }}<span v-if="val.length > 1 && index + 1 < val.length"
                  >、</span
                ></span
              >
            </li>
          </ul> -->
          <!-- 解析 -->
          <!-- <p
            class="lineH20"
            v-if="item.internalTypeId !== 9 && item.internalTypeId !== 10"
            v-html="'【解析】' + item.questionAnalysis"
          ></p> -->
          <!-- 用途 -->
          <!-- <p>
            【用途】
            <el-tag
              v-for="(label, label_index) in item.labels"
              :key="label_index"
              size="mini"
              :title="label.labelName"
              style="
                margin-right: 5px;
                max-width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                vertical-align: middle;
              "
              >{{ label.labelName }}</el-tag
            >
          </p> -->
        </div>
      </div>
      <!-- 组合题 -->
      <div
        v-if="questionObj.internalTypeId == 6"
        class="questionInfo group_question"
      >
        <p class="question_title">
          <span style="display: inline-block; width: calc(100% - 80px)">
            【<span>{{ questionObj.taskName }}</span
            >】
          </span>
        </p>
        <!-- 题干 -->
        <div
          class="div_content ql-editor"
          v-html="questionObj.questionContent"
        ></div>
        <!-- 小题 -->
        <div
          class="questionInfo"
          v-for="(childQuestion, cq_index) in questionObj.childQuestions"
          :key="cq_index"
        >
          <!-- 头部信息 -->
          <p class="flex_header">
            <span class="testDetail" v-if="childQuestion.internalTypeId === 1"
              >{{ cq_index + 1 }}、【单选题】</span
            >
            <span class="testDetail" v-if="childQuestion.internalTypeId === 2"
              >{{ cq_index + 1 }}、【多选题】</span
            >
            <span class="testDetail" v-if="childQuestion.internalTypeId === 3"
              >{{ cq_index + 1 }}、【判断题】</span
            >
            <span class="testDetail" v-if="childQuestion.internalTypeId === 4"
              >{{ cq_index + 1 }}、【填空题】</span
            >
            <span class="testDetail" v-if="childQuestion.internalTypeId === 5"
              >{{ cq_index + 1 }}、【简答题】</span
            >
            <span class="testDetail" v-if="childQuestion.internalTypeId === 9"
              >{{ cq_index + 1 }}、【实操题】</span
            >
            <span class="testDetail" v-if="childQuestion.internalTypeId === 10"
              >{{ cq_index + 1 }}、【附件题】</span
            >
          </p>
          <!-- 题干 -->
          <div
            class="div_content ql-editor"
            v-html="childQuestion.questionContent"
          ></div>
          <!-- 选择题 -->
          <ul
            v-if="
              childQuestion.internalTypeId === 1 ||
              childQuestion.internalTypeId === 2
            "
          >
            <li
              :class="{
                actived:
                  childQuestion.questionAnswer.indexOf(option.itemKey) != -1,
              }"
              v-for="(option, op_index) in childQuestion.items"
              :key="op_index"
              v-html="option.itemKey + '. ' + option.itemValue"
            ></li>
          </ul>
        </div>

        <div class="answer">
          <!-- 知识点 -->
          <p>
            <span class="label">【知识点】:</span>
            <span
              v-for="(material, m_index) in questionObj.materials"
              :key="m_index"
            >
              <el-tag
                v-if="material"
                size="mini"
                :title="material.name"
                class="my_tag"
                >{{ material.name }}</el-tag
              >
            </span>
          </p>
          <!-- 公司 -->
          <p>
            <span class="label">【公司】:</span>
            <span>
              {{ questionObj.companyNameUp }}
            </span>
          </p>
          <!-- 标签 -->
          <p>
            <span class="label">【标签】:</span>
            <el-tag
              v-for="(
                personLabel, personLabel_index
              ) in questionObj.personLabels"
              :key="personLabel_index"
              size="mini"
              :title="personLabel.labelName"
              class="my_tag"
              >{{ personLabel.labelName }}</el-tag
            >
          </p>
          <!-- 备注 -->
          <p>
            <span class="label">【备注】:</span>
            <span> 修改人：{{ questionObj.updateName }} </span>
            <span class="updateTime">
              修改时间：{{ questionObj.updateTime }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../../../../api/newCourseApi";
export default {
  name: "questionPreview",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    questionId: {
      type: [Number, String],
      default: "",
    },
    subjectId: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      questionObj: {},
      companyData: [],
    };
  },
  created() {
    this.findCompanyBySubjectId();
  },
  mounted() {},
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.findCompanyBySubjectId();
      }
    },
  },
  methods: {
    findCompanyBySubjectId() {
      api.FindCompanyBySubjectId({
        subjectId: this.subjectId
      }).then(res => {
        if (res.code == "0") {
          this.companyData = res.data;
          this.queryQuestionById();
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err);
      })
    },
    queryQuestionById() {
      console.log(this.questionId);
      api
        .QueryQuestionById(this.questionId)
        .then((res) => {
          if (res.code == "0") {
            let obj = res.data;
            [].forEach.call(this.companyData, item => {
              if (item.id == obj.companyId) {
                obj.companyNameUp = item.name;
              }
            })
            this.questionObj = obj;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.questionPreview {
  height: 430px;
  overflow: auto;
  .title {
    height: 47px;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #42414d;
    border-bottom: 1px solid #ededf0;
    margin-bottom: 8px;
    p {
      margin-right: 48px;
    }
  }
  .questionInfo {
    position: relative;
    .num {
      font-size: 16px;
      font-weight: bolder;
    }
    .title_info {
      color: #9498a3;
    }
    .title_border {
      &::after {
        content: "";
        display: inline-block;
        width: 2px;
        height: 14px;
        background-color: #9498a3;
        margin: 0px 10px;
        vertical-align: middle;
        margin-top: -3px;
      }
    }
    .question_title {
      margin-bottom: 4px;
      color: #0f0d11;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      font-size: 12px;
    }
    .div_content {
      clear: both;
      width: 99%;
      text-align: justify;
      margin-bottom: 10px;
      overflow: hidden;
      padding-left: 0px;
      padding-right: 0px;
      /deep/ img {
        max-width: 90%;
        display: block;
      }
      /deep/ p {
        word-break: break-word;
      }
    }
    ul {
      list-style: none;
      padding: 0px;
      border-bottom: 1px solid #ededf0;
      li {
        font-size: 14px;
        margin-bottom: 16px;
        padding-left: 32px;
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
        &.actived {
          color: #5397f7;
          /deep/ p {
            color: #5397f7;
          }
        }
        /deep/ p {
          display: inline-block;
          img {
            max-width: 60%;
          }
        }
      }
    }
    .answer {
      font-size: 12px;
      margin-top: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #767484;
      span {
        color: #767484;
      }
      .label {
        font-weight: 600;
        color: #767484;
        margin-right: 11px;
      }
      .updateTime {
        margin-left: 30px;
      }
      p {
        line-height: 22px;
        word-break: break-word;
        margin-bottom: 5px;
        p {
          display: inline-block;
          img {
            max-width: 60%;
          }
        }
      }
      .my_tag {
        margin-right: 5px;
        margin-bottom: 5px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        background: #f5f5f7;
        border: 0px;
      }
    }
  }
  .group_question .questionInfo {
    background: #f5f5f7;
    padding: 16px 24px;
    margin-bottom: 8px;
    .testDetail {
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0F0D11;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/question/questionPreview.vue